import React from 'react';

const UserFormModal = React.lazy(() => import('../components/FormModal'));
const userModalRegistry = {
    core_userId: UserFormModal
};
export default userModalRegistry;
